export default __webpack_public_path__ + "static/media/special-events-tablet@2x.2185a41f.jpg";